import React, { Fragment, useContext } from "react"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText/ListItemText"
import Divider from "@material-ui/core/Divider"
import Avatar from "@material-ui/core/Avatar"
import { useSideHeaderStyle } from "./style"
import { AppContext } from "Views/Home/context"

const logoSrc = "https://i-young.guokr.net/FmnjdUvl548Y1jcuqC75O_V1FLqX"
const avatarSrc = "http://1-im.guokr.com/97-WG9XAg2x5sdEEGaxrQzQYJ5Y4y6reCEzsF7MbC6_wFQAAoA4AAEpQ.jpg"

const SideHeader = () => {
    const classes = useSideHeaderStyle()
    const { user } = useContext(AppContext)
    const { nickname, role } = user || {}
    const { name: roleName } = role || {}
    return (
        <Fragment>
            <ListItem>
                <ListItemAvatar>
                    <a href="https://www.guokr.com">
                        <img className={classes.logo} src={logoSrc} alt="logo"/>
                    </a>
                </ListItemAvatar>
                <ListItemText primary="Schedule" />
            </ListItem>
            <Divider light variant="middle" className={classes.divider}/>
            {
                nickname && (
                    <ListItem alignItems="center" className={classes.userInfo}>
                        <ListItemAvatar>
                            <Avatar alt={nickname} src={avatarSrc} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={nickname}
                            secondary={roleName || ""}
                            secondaryTypographyProps={{ style: { color: "white" } }}/>
                    </ListItem>
                )
            }
            <Divider light variant="middle" className={classes.divider}/>
        </Fragment>
    )
}

export default SideHeader
